import { Button, Typography } from "@mui/material";
import React from "react";
import theme from "../theme/theme";

interface Props {
  leftComponent?: any;
  title: string;
  rightComponent?: any;
  rootStyle?: React.CSSProperties;
  titleStyle?: React.CSSProperties;
  onClick?: any;
  disabled?: boolean;
  hoverStyle?:React.CSSProperties;
  startIcon?:JSX.Element
}

const CustomButton: React.FC<Props> = ({
  leftComponent,
  title,
  rightComponent,
  rootStyle,
  titleStyle,
  onClick,
  disabled,
  hoverStyle,
  startIcon,
}) => {
  return (
    <Button
      variant="outlined"
      startIcon={startIcon}
      sx={{
        backgroundColor: theme.colors.primary,
        color: theme.colors.white,
        paddingLeft: 2,
        paddingRight: 2,
        alignItems: "center",
        borderColor: "transparent",
        ":hover": {
          bgcolor: rootStyle?.backgroundColor || theme.colors.primary,
          ...hoverStyle
        },
        ...rootStyle,
      }}
      disabled={disabled}
      onClick={onClick}
    >
      {leftComponent}
      {title ? (
        <Typography textTransform={"none"} sx={{ ...titleStyle }}>
          {title}
        </Typography>
      ) : null}
      {rightComponent}
    </Button>
  );
};

export default CustomButton;
